import { soddApi } from "./soddApi";

export const userApi = soddApi.injectEndpoints({
    endpoints: (build) => ({
        whoami: build.query({
            providesTags: ["user.me"],
            query: () => ({ url: "api/v1/users/whoami", method: "GET" }),
        }),
        getUserById: build.query({
            query: ({ userId }) => ({
                url: `api/v1/users/${userId}`,
                method: "GET",
            }),
            providesTags: ["user"],
            // providesTags: (result, _, arg) => (result ? [{ type: "user", id: arg.userId }] : ["user"]),
        }),
        getGroupsByUserId: build.query({
            query: ({ userId }) => ({
                url: `api/v1/users/${userId}/groups`,
                method: "GET",
            }),
            providesTags: ["group"],
        }),
        searchGroups: build.query({
            query: ({ userId, ...params }) => ({
                url: `api/v1/users/${userId}/groups/search`,
                method: "GET",
                params: params,
            }),
            providesTags: ["group"],
        }),
    }),
});

userApi.enhanceEndpoints({
    addTagTypes: ["user", "user.me", "group"],
});

export const { useWhoamiQuery, useGetUserByIdQuery, useGetGroupsByUserIdQuery, useSearchGroupsQuery } = userApi;
